import React, { useState, useEffect } from 'react';

interface CustomShortcut {
  id: string;
  key: string;
  ctrl: boolean;
  shift: boolean;
  alt: boolean;
  action: string;
}

export function KeyboardSettings() {
  const [customShortcuts, setCustomShortcuts] = useState<CustomShortcut[]>(() => {
    try {
      const saved = localStorage.getItem('xf_keyboard_shortcuts');
      return saved ? JSON.parse(saved) : [
        { id: 'ctrl+s', key: 's', ctrl: true, shift: false, alt: false, action: 'save-settings' },
        { id: 'ctrl+/', key: '/', ctrl: true, shift: false, alt: false, action: 'open-help' },
      ];
    } catch {
      return [];
    }
  });

  const handleSave = () => {
    try {
      localStorage.setItem('xf_keyboard_shortcuts', JSON.stringify(customShortcuts));
      toast.success('快捷键配置已保存');
    } catch (err) {
      toast.error('保存失败');
    }
  };

  const handleDelete = (id: string) => {
    setCustomShortcuts(prev => prev.filter(s => s.id !== id));
  };

  return (
    <div className="space-y-4 p-4 bg-white/[0.03] rounded-xl border border-white/5">
      <h3 className="text-white/70 text-sm font-semibold">快捷键管理</h3>
      
      <div className="space-y-2">
        {customShortcuts.map((shortcut) => (
          <div key={shortcut.id} className="flex items-center gap-3 p-2 bg-white/[0.02] rounded-lg">
            <span className="text-xs text-white/45 w-40">{shortcut.action}</span>
            <kbd className="bg-white/10 px-3 py-1.5 rounded text-xs font-mono text-white/80">
              {shortcut.ctrl ? 'Ctrl+' : ''}{shortcut.shift ? 'Shift+' : ''}{shortcut.alt ? 'Alt+' : ''}{shortcut.key.toUpperCase()}
            </kbd>
            <button
              onClick={() => handleDelete(shortcut.id)}
              className="ml-auto text-xs text-red-400 hover:text-red-300 transition-colors"
            >
              删除
            </button>
          </div>
        ))}
      </div>
      
      <button
        onClick={handleSave}
        className="w-full py-2 bg-celestial-saturn/10 border border-celestial-saturn/30 rounded-lg text-xs font-bold uppercase tracking-widest text-celestial-saturn hover:bg-celestial-saturn/20 transition-all"
      >
        保存配置
      </button>
    </div>
  );
}

// Helper for toast
const toast = {
  success: (msg: string) => console.log('[Toast Success]', msg),
  error: (msg: string) => console.error('[Toast Error]', msg),
};
